import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Segmented from "../../segmented/Segmented.jsx";
import ModalComponent from "../../modals/ModalComponent.jsx";
import Copy from "../../copy/Copy.jsx";
import Support from "../../../assets/Support.jsx";
import { Spin, Carousel, Progress } from "antd";
import { GetActiveBanner } from "../../../api/request/header/getActiveBanner.js";
import GoogleTranslate from "../../common/GoogleTranslate.jsx";
import { getCorporateAccount } from "../../../api/request/corporate";
import { getIndividualAccount } from "../../../api/request/individualOnboarding";
import { setCorporateCompletedPercentage } from "../../../store/Slices/corporateSlice";
import { setIndividualCompletedPercentage } from "../../../store/Slices/individualSlice";
import { ACCOUNT_TYPE, canSwitchIbDashboard, getOnboardingPath, resolveAccountType } from "../../../utils/onboarding.js";


const CustomHeader = ({ collapsed, setCollapsed, isDrawerOpen, setIsDrawerOpen, ib, title }) => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userDetails } = useSelector(state => state.user);
  const { completedPercentage: corporateCompletedPercentage } = useSelector(
    (state) => state.corporate || { completedPercentage: 0 }
  );
  const { completedPercentage: individualCompletedPercentage } = useSelector(
    (state) => state.individual || { completedPercentage: 0 }
  );
  const accountType = resolveAccountType(userDetails);
  const completedPercentage =
    accountType === ACCOUNT_TYPE.INDIVIDUAL
      ? individualCompletedPercentage
      : corporateCompletedPercentage;
  const showIbDashboardSwitch = canSwitchIbDashboard(userDetails);
  const onboardingPath = getOnboardingPath(userDetails);
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue("--theme")?.trim();
  const [value, setValue] = useState(ib ? "IB Dashboard" : 'User Dashboard');
  const [fetched, setFetched] = useState(false);
  const [isOpenParentDetails, setIsOpenParentDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVisibleParent, setIsVisibleParent] = useState(false);
  const [data, setData] = useState(null);
  const [isBanner, setIsBanner] = useState(false);
  const [bannerData, setBannerData] = useState([null]);


  const getActiveBanner = async () => {
    try {
      const filterByCategory = value === "User Dashboard" ? 'user' : 'ibuser';
      const params = {
        filterByCategory,
        bannerViewType: 'web'
      };
      const { data } = await GetActiveBanner(new URLSearchParams(params).toString());
      if (data?.success) {
        setBannerData(data?.data[0]);
      }
    }
    catch (error) {
    }
  }

  useEffect(() => {
    getActiveBanner();
  }, []);

  const fetchCorporateOnboarding = async () => {
    try {
      if (accountType !== ACCOUNT_TYPE.CORPORATE) return;
      const { data } = await getCorporateAccount();
      if (data?.success) {
        dispatch(setCorporateCompletedPercentage(data?.data?.completedPercentage));
      }
    } catch (error) { }
  };

  const fetchIndividualOnboarding = async () => {
    try {
      if (accountType !== ACCOUNT_TYPE.INDIVIDUAL) return;
      const { data } = await getIndividualAccount();
      if (data?.success) {
        dispatch(setIndividualCompletedPercentage(data?.data?.completedPercentage));
      }
    } catch (error) { }
  };

  useEffect(() => {
    fetchCorporateOnboarding();
    fetchIndividualOnboarding();
  }, [accountType]);

  useEffect(() => {
    if (fetched) {
      if (value === 'IB Dashboard') {
        navigate('/ib/dashboard')
      } else if (value === 'User Dashboard') {
        navigate('/dashboard')
      }
    } else {
      setFetched(true)
    }
  }, [value]);

  useEffect(() => {
    // getParentDetails();
  }, []);

  // const getParentDetails = async () => {
  //   try {
  //     setIsLoading(true);
  //     const { data } = await ParentDetails();
  //     if (data?.success) {
  //       setData(data?.data);
  //       if (data?.data?.email) {
  //         setIsVisibleParent(true);
  //       }
  //     }
  //     setIsLoading(false);
  //   } catch (error) {
  //     setIsLoading(false);
  //   }
  // }

  const openUserListModal = () => {
    setIsOpenParentDetails(true);
    if (data == null) {
      // getParentDetails();
    }
  }
  const onChange = (currentSlide) => {
  };


  return (
    <div className="border-b p-4 ">
      <div className="min-h-10 h-auto flex justify-between items-center">
        <div className="flex items-center">
          <div className="md:hidden">
            <svg onClick={() => setCollapsed(!collapsed)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 cursor-pointer hidden lg:block">
              <path fill-rule="evenodd" d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
            </svg>
          </div>
          <svg onClick={() => setIsDrawerOpen(!isDrawerOpen)} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6 cursor-pointer lg:hidden">
            <path fill-rule="evenodd" d="M3 6.75A.75.75 0 0 1 3.75 6h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 6.75ZM3 12a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75A.75.75 0 0 1 3 12Zm0 5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75Z" clip-rule="evenodd" />
          </svg>
          <p className="ml-4 text-lg font-bold text-[#2F2B3D] uppercase hidden md:block">{title}</p>
          <div className="sm:ms-5 flex items-center">
            {bannerData?.bannerUrl
              ? <div className="rounded-full bg-secondary h-3 w-3 me-1 dotanim"></div> : ""}
            {bannerData?.bannerUrl
              ? <p onClick={e => setIsBanner(true)} className="sm:text-lg text-sm text-white bg-primary rounded-sm px-2 font-medium  cursor-pointer ">News</p> : ""}
          </div>
        </div>
        <div className="flex flex-wrap justify-end items-center gap-2 sm:gap-4 relative z-10 min-w-0">
          {showIbDashboardSwitch && (
            <div className="shrink-0">
              <Segmented
                options={[
                  {
                    label: (
                      <span>
                        <span className="hidden sm:inline">User Dashboard</span>
                        <span className="sm:hidden">User</span>
                      </span>
                    ),
                    value: 'User Dashboard',
                  },
                  {
                    label: (
                      <span>
                        <span className="hidden sm:inline">IB Dashboard</span>
                        <span className="sm:hidden">IB</span>
                      </span>
                    ),
                    value: 'IB Dashboard',
                  },
                ]}
                value={value}
                setValue={setValue}
              />
            </div>
          )}
          {onboardingPath && !ib && (
            <div className="flex items-center gap-2 shrink-0">
              <button
                onClick={() => navigate(onboardingPath)}
                className="bg-primary text-white px-4 py-2 rounded-lg font-semibold hover:opacity-90 transition-opacity"
              >
                Onboarding
              </button>
              <div className="hidden sm:block">
                <Progress
                  type="circle"
                  percent={completedPercentage || 0}
                  size={32}
                  showInfo
                  strokeColor={primaryColor || "#014167"}
                />
              </div>
            </div>
          )}
          {
            (showIbDashboardSwitch && (window.location?.pathname).substring(0, 3) == '/ib') ?
              (<div className="flex items-center justify-center gap-3">
                <>
                  <div className="bg-primary-light px-3 py-1 rounded-lg flex ">
                    <p className="me-2"><span >Sub-IB Link</span> </p>
                    <Copy text={`${window?.location?.origin}/?tab=register&ref=${userDetails?.referralCode}&role=ibuser`} />
                  </div>
                  <div className="bg-primary-light px-3 py-1 rounded-lg flex">
                    <p className="me-2"><span className="xl:inline-block hidden">IB Code:</span> {userDetails?.referralCode}</p>
                    <Copy text={`${window?.location?.origin}/?tab=register&ref=${userDetails?.referralCode}`} />
                  </div>
                </>
              </div>) : (
                <div>
                  {userDetails?.isShowParentDetail &&
                    <div className="flex justify-center items-center gap-2">
                      <p className="primary font-semibold">Parent Details</p>
                      <div onClick={openUserListModal}>
                        <Support />
                      </div>
                    </div>
                  }
                </div>
              )
          }

          {/* Google Translate */}
          <GoogleTranslate />
        </div>

        <ModalComponent isOpen={isOpenParentDetails} setIsOpen={setIsOpenParentDetails} title='Parent Details' width={1200}>
          <div className='p-5'>
            {isLoading ? (
              <div className="flex justify-center flex-col my-5">
                <Spin size="large" />
                <p className="primary text-center mt-2">Loading...</p>
              </div>
            ) : (
              <div className='grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 gap-10 '>
                <div>
                  <p className='text-base font-normal '>First Name</p>
                  <p className='text-xl primary font-semibold  mt-2'>{data?.firstName}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Last Name</p>
                  <p className='text-xl primary font-semibold  mt-2'>{data?.lastName}</p>
                </div>
                <div>
                  <p className='text-base font-normal '>Email</p>
                  <p className='text-xl primary font-semibold  mt-2'>{data?.email}</p>
                </div>
                {userDetails?.kycStatus === 'Approved' &&
                  <div>
                    <div className="lg:mt-6">
                      <button className="bg-primary text-sm text-white font-semibold px-9 py-2 rounded-lg themeHover duration-500" onClick={() => { setIsOpenParentDetails(false); navigate(`/inbox?ref=parent`) }}>Start Chat</button>
                    </div>
                  </div>
                }
              </div>
            )}
          </div>
        </ModalComponent>

        {/* getActiveBanner Modal */}
        <ModalComponent isOpen={isBanner} title={"Today's News"} setIsOpen={setIsBanner} width={800}>
          <Carousel autoplay>
            {bannerData?.bannerUrl?.map((item, index) => (
              <div key={index} >
                <img
                  src={item}
                  alt="banner"
                  className="rounded-lg"
                  preview={false}
                  style={{ width: '100%', height: '350px', objectFit: 'cover' }}
                />
              </div>
            ))}
          </Carousel>
          <p className="font-semibold text-lg mt-3 text-center">{bannerData?.bannerCaption}</p>
        </ModalComponent>
      </div>
    </div>
  );
};

export default CustomHeader;
